<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-高级设置
    -->
  <div class="buy-set-content pl16 pr16">
    <div class="common-form mt50">余额设置</div>
    <el-form-item label="是否开启余额赠送：">
      <el-radio-group v-model="form.model.balance_setting.open">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
      <div class="gray9">
          <p>注：如开启则订单完成后赠送用户余额，余额赠送规则：1.订单确认收货已完成；2.已完成订单超出后台设置的申请售后期限</p>
        </div>
    </el-form-item>
    <el-form-item label="余额赠送类型：" v-if="form.model.balance_setting.open==1">
      <el-radio-group v-model="form.model.balance_setting.balance_type">
        <el-radio :label="10">百分比</el-radio>
        <el-radio :label="20">固定金额</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="" v-if="form.model.balance_setting.open==1">
      <div class="max-w460">
        <el-input v-model="form.model.balance_setting.balance_amount" type="number" :min="0" class="max-w460" style="width:200px">
          <template slot="append">
            <span class="ml10" v-if="form.model.balance_setting.balance_type==10">%</span>
            <span class="ml10" v-else>余额</span>
          </template>
        </el-input>
      </div>
    </el-form-item>

    <!--积分设置-->
    <div class="common-form mt50">积分设置</div>
    <el-form-item label="是否开启积分赠送：">
      <el-radio-group v-model="form.model.points_setting.open">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
      <div class="gray9">
          <p>注：如开启则订单完成后赠送用户积分，积分赠送规则：1.订单确认收货已完成；2.已完成订单超出后台设置的申请售后期限</p>
        </div>
    </el-form-item>
    <div  v-if="form.model.points_setting.open==1">
      <el-form-item label="赠送类型：">
        <el-radio-group v-model="form.model.points_setting.rule_type">
          <el-radio :label="0">默认规则</el-radio>
          <el-radio :label="1">独立规则</el-radio>
        </el-radio-group>
        <div class="gray9" >默认规则，按照统一设置赠送积分</div>
      </el-form-item>
      <el-form-item label="赠送类型：" v-if="form.model.points_setting.rule_type==1">
        <el-radio-group v-model="form.model.points_setting.points_type" @change="changePointRatioType">
          <el-radio :label="10">百分比</el-radio>
          <el-radio :label="20">固定金额</el-radio>
        </el-radio-group>

      </el-form-item>

      <el-form-item label="" v-if="form.model.points_setting.rule_type==1">
        <div class="max-w460">
          <el-input v-model="form.model.points_setting.points_amount" type="number" :min="0" class="max-w460" style="width:200px">
            <template slot="append">
              <span class="ml10">{{ points_ratio_unit }}</span>
            </template>

          </el-input>
        </div>
      </el-form-item>
    </div>


    <el-form-item label="是否允许使用积分抵扣：">
      <el-radio-group v-model="form.model.is_points_discount">
        <el-radio :label="1">允许</el-radio>
        <el-radio :label="0">不允许</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="积分抵扣类型：" v-if="form.model.is_points_discount==1">
      <el-radio-group v-model="form.model.alone_credit_type" @change="changeCreditType">
        <el-radio :label="10">百分比</el-radio>
        <el-radio :label="20">固定金额</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="" v-if="form.model.is_points_discount==1">
      <div class="max-w460">
        <el-input v-model="form.model.points_discount" class="max-w460" style="width:200px">
          <template slot="append">
            <span class="ml10">{{ credit_unit }}</span>
          </template>

        </el-input>
      </div>
    </el-form-item>

    <!--商品购买权限-->
    <div class="common-form mt50">商品权限 </div>

      <el-form-item label="用户购买权限">
        <el-select v-model="form.model.buy_auth" multiple placeholder="请选择">
          <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name"  :value="item.grade_id">
          </el-option>
        </el-select>
          <div class="gray9">选择后，只有选中的会员等级用户才能购买当前商品，不设置所有用户都可以购买</div>
      </el-form-item>
      <el-form-item label="用户查看权限">
        <el-select v-model="form.model.check_auth" multiple placeholder="请选择">
          <el-option v-for="(item,index) in form.gradeList" :key="index" :label="item.name"  :value="item.grade_id">
          </el-option>
        </el-select>
          <div class="gray9">只有选中的会员等级用户才能查看当前商品，不设置所有用户都能查看</div>
      </el-form-item>
        
      <el-form-item label="升级的等级：" prop="model.up_grade_id">
        <el-select v-model="form.model.up_grade_id" clearable>
          <el-option v-for="item in form.gradeList" :value="item.grade_id" :key="item.name" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="升级单数累计：">
        <el-radio-group v-model="form.model.is_grade_goods">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <div class="gray">选择是，下单后将参与用户升级累计</div>
      </el-form-item> -->
      <el-form-item label="单次限购数量：">
        <el-input type="number" min="0" v-model="form.model.buy_limit_num" class="max-w460" style="width:200px">
          <template slot="append">件 (默认0为不限)</template>
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="核销奖励：" v-auth="'/store/store/index'">
        <el-input type="number" min="0" v-model="form.model.verification_reward" class="max-w460" style="width:200px">
          <template slot="append">元/件</template>
        </el-input>
        <div class="gray">设置后，门店核销员可获得该部分奖励</div>
      </el-form-item> -->
      
      
      <el-form-item label="是否开启最低购买限制：">
        <el-radio-group v-model="form.model.open_min_buy">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否按倍数购买：" v-if="form.model.open_min_buy==1">
        <el-radio-group v-model="form.model.is_multiple">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <div class="gray9">开启后，购买此商品以倍数下单</div>
      </el-form-item>
      <el-form-item label="最低下单数量设置:"  v-if="form.model.open_min_buy==1">
        <div class="max-w460">
          <el-table :data="form.gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="等级">
            </el-table-column>
            <el-table-column prop="name" label="最低下单数量">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.buy_total_set" type="number" placeholder="请输入下单数量"></el-input>
                  <span class="ml10">件</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <el-form-item label="累计限购数量：">
        <el-input  type="number" min="0"  v-model="form.model.buy_total_num" class="max-w460" style="width:200px">
          <template slot="append">件 (默认0为不限)</template>
        </el-input>
      </el-form-item>
      <el-form-item v-auth="'/supplier'" label="所属供货商：" prop="model.supplier_id">
        <el-select v-model="form.model.supplier_id" clearable>
          <el-option v-for="item in form.supplierList" :value="item.supplier_id" :key="item.company_name" :label="item.company_name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-auth="'/supplier'" label="平台抽佣比例：">
        <el-input v-model="form.model.platform_commission" class="max-w460" style="width:200px">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

    <!--会员折扣设置-->
    <div class="common-form mt50">会员折扣设置</div>
    <el-form-item label="是否开启会员折扣：">
      <el-radio-group v-model="form.model.is_enable_grade">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="会员折扣设置：" v-if="form.model.is_enable_grade ==1">
      <el-radio-group v-model="form.model.is_alone_grade">
        <el-radio :label="0">默认折扣</el-radio>
        <el-radio :label="1">单独设置折扣</el-radio>
      </el-radio-group>
      <div class="gray9" v-if="form.model.is_alone_grade==0">默认折扣：默认为用户所属会员等级的折扣率</div>
    </el-form-item>

    <el-form-item label="折扣类型：" v-if="form.model.is_alone_grade==1 && form.model.is_enable_grade ==1">
      <el-radio-group v-model="form.model.alone_grade_type" @change="changeGradeType">
        <el-radio :label="10">百分比</el-radio>
        <el-radio :label="20">固定金额</el-radio>
      </el-radio-group>
    </el-form-item>


    <el-form-item label="" v-if="form.model.is_alone_grade==1 && form.model.is_enable_grade ==1">
      <div class="max-w460">
        <el-table :data="form.gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="会员等级">
          </el-table-column>
          <el-table-column prop="name" label="折扣">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_equity" type="number" placeholder="请输入折扣"></el-input>
                <span class="ml10">{{ grade_unit }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <el-form-item label="是否开启会员折扣差奖励：" v-if="form.model.is_enable_grade ==1"  v-auth="'/plus/agent/discount/price'">
      <el-radio-group v-model="form.model.is_enable_grade_discount">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
      <div class="gray9" v-if="form.model.is_enable_grade_discount==0">关闭后用户下单时不计算会员折扣差奖励</div>
    </el-form-item>

    <!-- 产品收益设置 -->
    <div v-auth="'/productprofits'">
      <div class="common-form mt50">产品收益设置</div>
      <el-form-item label="收益模式：">
        <el-radio-group v-model="form.model.earning_setting.type">
          <el-radio :label="0">本息同返</el-radio>
          <el-radio :label="1">先息后本</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="托管收益率" class="max-w460" :rules="[{ required: true, message: '收益率' }]" prop="model.earning_setting.rate">
        <el-input v-model="form.model.earning_setting.rate" min="0" type="number" placeholder="收益率">
            <template slot="append">
              %
            </template>
          </el-input>
          收益率，设置后则表明参与收益活动
      </el-form-item>
      <el-form-item label="托管月份" class="max-w460" :rules="[{ required: true, message: '托管月份' }]" prop="model.earning_setting.month">
        <el-input v-model="form.model.earning_setting.month" min="0" type="number" placeholder="托管月份">
            <template slot="append">
              月
            </template>
          </el-input>
          不设置奖默认为12个月
      </el-form-item>
      <el-form-item label="产生收益时间" class="max-w460" :rules="[{ required: true, message: '收益时间' }]" prop="model.earning_setting.limit_days">
        <el-input v-model="form.model.earning_setting.limit_days" min="0" type="number" placeholder="收益时间">
            <template slot="append">
              天后
            </template>
          </el-input>
          不设置将默认10天后获得收益
      </el-form-item>
    </div>
    
    <!--平台分红设置-->
    <div class="common-form mt50" v-auth="'/plus/bonus/index'">平台分红设置</div>
    <el-form-item label="奖金池金额:" v-auth="'/plus/bonus/index'">
      <div class="max-w460">
        <el-table :data="form.gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="会员等级">
          </el-table-column>
          <el-table-column prop="name" label="奖金池金额">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_bonus" type="number" placeholder="请输入奖金池金额"></el-input>
                <span class="ml10">元</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <!--分销设置-->
    <div class="common-form mt50" v-auth="'/plus/agent/index'">分销设置</div>
    <el-form-item v-auth="'/distributor'" label="渠道分销奖励：">
      <el-input v-model="form.model.distrbution_money" class="max-w460" style="width:200px">
        <template slot="append">%</template>
      </el-input>
    </el-form-item>
    <el-form-item label="是否开启单独分销："  v-auth="'/plus/agent/index'">
      <el-radio-group v-model="form.model.is_ind_agent">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="分销类型："  v-auth="'/plus/agent/index'" v-if="form.model.is_ind_agent ==1">
       <el-radio-group v-model="form.model.commission_type">
         <el-radio :label="0">统一</el-radio>
         <el-radio :label="1">按等级</el-radio>
       </el-radio-group>
     </el-form-item>
     <template v-if="form.model.is_ind_agent === 1 && form.model.commission_type === 0"  v-auth="'/plus/agent/index'">
      <el-form-item label="分销佣金类型：">
        <el-radio-group v-model="form.model.agent_money_type" @change="changeMoneyType">
          <el-radio :label="10">百分比</el-radio>
          <el-radio :label="20">固定金额</el-radio>
        </el-radio-group>
        <div class="red"  v-if="show_profit_member">复购定义：非系统默认会员购物,需要分销设置中开启设置后生效</div>
      </el-form-item>
      <el-form-item label="单独分销设置：">
        <el-input type="number" min="0" v-model="form.model.first_money" class="max-w300">
          <template slot="prepend">
            一级佣金：
          </template>
          <template slot="append">
            {{ unit }}
          </template>
        </el-input>
        <el-input type="number" min="0" v-model="form.model.first_money_member" class="max-w300" v-if="show_profit_member">
          <template slot="prepend">
            一级佣金（复购）：
          </template>
          <template slot="append">
            {{ unit }}
          </template>
        </el-input>
        <el-input type="number" min="0" v-model="form.model.first_point" class="max-w300" v-auth="'/plus/agent/point'">
          <template slot="prepend">
            一级积分：
          </template>
          <template slot="append">
            {{ point_unit }}
          </template>
        </el-input>
      </el-form-item>
      <el-form-item v-if="form.basicSetting.level >= 2">
        <el-input type="number" min="0" v-model="form.model.second_money" class="max-w300">
          <template slot="prepend">
            二级佣金：
          </template>
          <template slot="append">
            {{ unit }}
          </template>
        </el-input>
        <el-input type="number" min="0" v-model="form.model.second_money_member" class="max-w300" v-if="show_profit_member">
          <template slot="prepend">
            二级佣金(复购）：
          </template>
          <template slot="append">
            {{ unit }}
          </template>
        </el-input>
        <el-input type="number" min="0" v-model="form.model.second_point" class="max-w300" v-auth="'/plus/agent/point'">
          <template slot="prepend">
            二级积分：
          </template>
          <template slot="append">
            {{ point_unit }}
          </template>
        </el-input>
      </el-form-item>
      <el-form-item v-if="form.basicSetting.level >= 3">
        <el-input type="number" min="0" v-model="form.model.third_money" class="max-w300">
          <template slot="prepend">
            三级佣金：
          </template>
          <template slot="append">
            {{ unit }}
          </template>
        </el-input>
        <el-input type="number" min="0" v-model="form.model.third_money_member" class="max-w300" v-if="show_profit_member">
          <template slot="prepend">
            三级佣金（复购）：
          </template>
          <template slot="append">
            {{ unit }}
          </template>
        </el-input>
        <el-input type="number" min="0" v-model="form.model.third_point" class="max-w300" v-auth="'/plus/agent/point'">
          <template slot="prepend">
            三级积分：
          </template>
          <template slot="append">
            {{ point_unit }}
          </template>
        </el-input>
      </el-form-item>
    </template>
    <template v-if="form.model.is_ind_agent === 1 && form.model.commission_type === 1"  v-auth="'/plus/agent/index'">
      <el-form-item label="分销佣金类型：">
        <el-radio-group v-model="form.model.agent_money_type" @change="changeMoneyType">
          <el-radio :label="10">百分比</el-radio>
          <el-radio :label="20">固定金额</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="单独分销设置：">
        <div style="max-width: 800px;">
          <el-table :data="form.gradeList" border style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="佣金设置" width="650px">
              <template v-slot="scope">
                  <el-input type="number" min="0" v-model="scope.row.first_money" class="max-w300">
                    <template slot="prepend">
                      一级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                  <el-input type="number" min="0" v-model="scope.row.first_money_member" class="max-w300" v-if="show_profit_member">
                    <template slot="prepend">
                      一级佣金（复购）：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                  <el-input type="number" min="0" v-model="scope.row.first_point" class="max-w300" v-auth="'/plus/agent/point'">
                    <template slot="prepend">
                      一级积分：
                    </template>
                    <template slot="append">
                      {{ point_unit }}
                    </template>
                  </el-input>
                  <el-form-item v-if="form.basicSetting.level >= 2">
                    <el-input type="number" min="0" v-model="scope.row.second_money" class="max-w300">
                      <template slot="prepend">
                        二级佣金：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                    <el-input type="number" min="0" v-model="scope.row.second_money_member" class="max-w300" v-if="show_profit_member">
                      <template slot="prepend">
                        二级佣金（复购）：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                    <el-input type="number" min="0" v-model="scope.row.second_point" class="max-w300" v-auth="'/plus/agent/point'">
                      <template slot="prepend">
                        二级积分：
                      </template>
                      <template slot="append">
                        {{ point_unit }}
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-if="form.basicSetting.level >= 3">
                    <el-input type="number" min="0" v-model="scope.row.third_money" class="max-w300">
                      <template slot="prepend">
                        三级佣金：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                    <el-input type="number" min="0" v-model="scope.row.third_money_member" class="max-w300" v-if="show_profit_member">
                      <template slot="prepend">
                        三级佣金（复购）：
                      </template>
                      <template slot="append">
                        {{ unit }}
                      </template>
                    </el-input>
                    <el-input type="number" min="0" v-model="scope.row.third_point" class="max-w300" v-auth="'/plus/agent/point'">
                      <template slot="prepend">
                        三级积分：
                      </template>
                      <template slot="append">
                        {{ point_unit }}
                      </template>
                    </el-input>
                  </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </template>

    <div class="common-form mt50"  v-auth="'/plus/agent/discount/index'">团队平级奖设置</div>
    <el-form-item label="是否开启：" v-auth="'/plus/agent/discount/index'" >
      <el-radio-group v-model="form.model.is_alone_enable_grade_equity">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="奖励类型" v-if="form.model.is_alone_enable_grade_equity==1">
      <el-radio-group v-model="form.model.alone_enable_grade_type" @change="changeGradeLevelType">
        <el-radio :label="10">按百分比</el-radio>
        <el-radio :label="20">固定金额</el-radio>
      </el-radio-group>
      <div class="gray9" v-if="form.model.is_alone_grade==0">百分比以用户产品实付金额为基数</div>
    </el-form-item>
    <el-form-item label="" v-if="form.model.is_alone_enable_grade_equity==1 " v-auth="'/plus/agent/discount/index'">
      <div class="max-w650">
        <el-table :data="form.gradeRangeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="会员等级">
          </el-table-column>
          <el-table-column prop="name" label="团队奖励">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.grade_award" type="number" placeholder="请输入数字额">
                  <template slot="append">{{grade_level_unit}}</template>
                </el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="平级奖励">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.same_award" type="number" placeholder="请输入数字额">
                  <template slot="append">{{grade_level_unit}}</template>
                </el-input>
              </div>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </el-form-item>

    <div class="common-form mt50"  v-auth="'/warehouse/productwarehouse'">商品关联云仓设置</div>
    <el-form-item label="是否开启商品关联云仓：" v-auth="'/warehouse/productwarehouse'">
      <el-radio-group v-model="form.model.is_use_warehouse_product">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
      <div class="gray9">开启后，购买此商品会给购买者添加对应的商品云仓</div>
    </el-form-item>
    <el-form-item label="商品管理" v-if="form.model.is_use_warehouse_product==1" v-auth="'/warehouse/productwarehouse'">
      <el-button icon="el-icon-plus" @click="changeProduct(form.model.warehouse_product_list)">选择商品</el-button>
      <div class="pt16">
        <el-table size="mini" :data="form.model.warehouse_product_list" border style="width: 500px;">
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <p class="text-ellipsis-2">{{ scope.row.product_name }}</p>
            </template>
          </el-table-column>
          <el-table-column label="商品数量" width="100">
            <template slot-scope="scope">
              <el-input size="small" type="number" min="0" v-model="scope.row.product_num"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <el-form-item label="每月提货盒数设置:" v-auth="'/warehouse/productwarehouse'" >
      <div class="max-w460">
        <el-table :data="form.gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="等级">
          </el-table-column>
          <el-table-column prop="name" label="提货盒数">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.pick_total_set" type="number" placeholder="请输入起订数量"></el-input>
                <span class="ml10">件</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>

    <div v-auth="'/plus/agent/belongmode'">
        <div class="common-form mt50">2+1链动奖励参数设置</div>
        <!-- <el-form-item label="代理层级返利" class="max-w460" :rules="[{ required: true, message: '代理层级返利' }]" prop="model.boss_agent.agent_level_money">
          <el-input v-model="form.model.boss_agent.agent_level_money" min="0" type="number" placeholder="金额">
            <template slot="append">
              元
            </template>
          </el-input>
          <div class="gray9">设置后直推N个2+1代理可享受往下几代的固定返利</div>
        </el-form-item> -->
      <el-form-item label="是开启2+1链动奖励：">
        <el-radio-group v-model="form.model.boss_agent.open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.model.boss_agent.open==1" label="直推奖励" class="max-w460" :rules="[{ required: true, message: '直推奖励' }]" prop="model.boss_agent.agent_money">
        <el-input v-model="form.model.boss_agent.agent_money" min="0" type="number" placeholder="数值">
            <template slot="append">
              元
            </template>
          </el-input>
      </el-form-item>
      <el-form-item  v-if="form.model.boss_agent.open==1" label="见单奖励" class="max-w460" :rules="[{ required: true, message: '见单奖励' }]" prop="model.boss_agent.boss_money">
        <el-input v-model="form.model.boss_agent.boss_money" min="0"  type="number" placeholder="数值">
            <template slot="append">
              元
            </template>
          </el-input>
      </el-form-item>
      <el-form-item v-if="form.model.boss_agent.open==1"  label="直推平级奖励" class="max-w460" :rules="[{ required: true, message: '直推平级奖励' }]" prop="model.boss_agent.boss_peer">
        <el-input v-model="form.model.boss_agent.boss_peer" min="0"  type="number" placeholder="数值">
            <template slot="append">
              元
            </template>
          </el-input>
          <div class="red">见单奖励和直推平级奖励仅1级别以上的用户才能获得</div>
      </el-form-item>
      
    </div>

    <div  v-auth="'/regionagent'">
      <div class="common-form mt50">区域代理参数设置</div>
      <el-form-item label="是独立区域代理返利：">
        <el-radio-group v-model="form.model.area_agent.open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="区域奖励类型："  v-if="form.model.area_agent.open==1">
        <el-radio-group v-model="form.model.area_agent.agent_area_type" @change="changeAreaType">
          <el-radio :label="10">百分比</el-radio>
          <el-radio :label="20">固定金额</el-radio>
        </el-radio-group>
        <div class="gray9">选择百分比：区域代理返利=产品价格*百分比；选择固定金额：区域代理返利=产品数量*固定金额</div>
      </el-form-item>
      <el-form-item v-if="form.model.area_agent.open==1" label="省级区域奖励" class="max-w460" :rules="[{ required: true, message: '省级区域奖励' }]" prop="model.area_agent.province_rate">
        <el-input v-model="form.model.area_agent.province_rate" min="0" type="number" placeholder="数值">
            <template slot="append">
              {{ area_unit }}
            </template>
          </el-input>
      </el-form-item>
      <el-form-item  v-if="form.model.area_agent.open==1" label="市级区域奖励" class="max-w460" :rules="[{ required: true, message: '市级区域奖励' }]" prop="model.area_agent.city_rate">
        <el-input v-model="form.model.area_agent.city_rate" min="0"  type="number" placeholder="数值">
            <template slot="append">
              {{ area_unit }}
            </template>
          </el-input>
      </el-form-item>
      <el-form-item v-if="form.model.area_agent.open==1"  label="区级区域奖励" class="max-w460" :rules="[{ required: true, message: '区级区域奖励' }]" prop="model.area_agent.region_rate">
        <el-input v-model="form.model.area_agent.region_rate" min="0"  type="number" placeholder="数值">
            <template slot="append">
              {{ area_unit }}
            </template>
          </el-input>
      </el-form-item>
    </div>

  </div>
</template>

<script>
  import Product from '@/components/product/Product.vue';
  import { mergeTable } from '@/utils/table.js';
  export default {
    components: {
          /*选择商品组件*/
          Product,
        },
    data() {
      return {
        show_profit_member:false,
        /*产品去重*/
        excludeIds: [],
        /*是否打开选择商品*/
        isproduct: false,
        unit: '%',
        points_ratio_unit: '%',
        point_unit: '%',
        grade_unit: '%',
        credit_unit: '%',
        area_unit: '%',
        grade_level_unit:"%",
      };
    },
    created() {
      if(this.$filter.isAuth('/plus/agent/membercommission')) this.show_profit_member = true;
      if(this.form.model.alone_grade_type == '20'){
        this.grade_unit = '元';
      }
      if(this.form.model.agent_money_type == '20'){
        this.unit = '元';
        this.point_unit = '积分';
      }
      if(this.form.model.alone_credit_type == '20'){
        this.credit_unit = '元';
      }
      if(this.form.model.points_setting.points_type == '20'){
        this.points_ratio_unit = '积分';
      }
      if(this.form.model.area_agent.agent_area_type == '20'){
        this.area_unit = '元';
      }
      if(this.form.model.alone_enable_grade_type == '20'){
        this.grade_level_unit = '元';
      }
    },
    inject: ['form'],
    methods: {
      /*换算单位*/
      changeMoneyType: function(val) {
          if (val == '10') {
            this.unit = '%';
            this.point_unit = '%';
          } else {
            this.unit = '元';
            this.point_unit = '积分';
          }
      },
      /*换算单位*/
      changeCreditType: function(val) {
          if (val == '10') {
            this.credit_unit = '%';
          } else {
            this.credit_unit = '元';
          }
      },
      changePointRatioType: function(val) {
          if (val == '10') {
            this.points_ratio_unit = '%';
          } else {
            this.points_ratio_unit = '积分';
          }
      },
      /*换算单位*/
      changeAreaType: function(val) {
          if (val == '10') {
            this.area_unit = '%';
          } else {
            this.area_unit = '元';
          }
      },
      /*换算单位*/
      changeGradeType: function(val) {
          if (val == '10') {
            this.grade_unit = '%';
          } else {
            this.grade_unit = '元';
          }
      },
      /*换算单位*/
      changeGradeLevelType: function(val) {
          if (val == '10') {
            this.grade_level_unit = '%';
          } else {
            this.grade_level_unit = '元';
          }
      },

      /*打开添加*/
      changeProduct(list) {
        let arr = [];
        list.forEach(item => {
          arr.push(item.product_id);
        });
        this.excludeIds = arr;
        this.isproduct = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e) {
        let self = this;
        self.isproduct = false;
        if (e.type == 'success') {
          let arr = [];
          for (let i = 0; i < e.params.length; i++) {
            let item = e.params[i];
            let obj = {
              product_name: item.product_name,
              product_id: item.product_id,
              product_num: 1,
            };
            arr.push(obj);
          }
          self.form.model.warehouse_product_list = self.form.model.warehouse_product_list.concat(arr);
          self.form.model.warehouse_product_list = mergeTable(this.form.model.warehouse_product_list);
        }
      },
      /*删除*/
      deleteClick(e) {
        let curItem=this.form.model.warehouse_product_list[e];
        /*判断能删除产品*/
        for (let i = 0; i < this.form.model.warehouse_product_list.length; i++) {
          let item = this.form.model.warehouse_product_list[i];
          if (curItem.product_id == item.product_id) {
            this.form.model.warehouse_product_list.splice(i, 1);
            i--;
          }
        }
        if (this.form.model.warehouse_product_list.length > 0) {
          this.form.model.warehouse_product_list = mergeTable(this.form.model.warehouse_product_list);
        }else{
          this.form.model.warehouse_product_list = [];
        }
      },
    }
  };
</script>

<style>
  .max-w300 {
    max-width: 300px;
  }
  .max-w650{
    max-width: 650px;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Buyset.vue